import styles from './styles.module.scss'
import { Loader } from 'components/Loader/Loader'
import { CircularProgressProps } from '@mui/material'

export const AbsoluteLoader = (props: CircularProgressProps) => (
  <div className={styles.loader}>
    <Loader {...props} />
  </div>
)
